<template>
  <div>
    <v-card class="align-start">
      <v-card-title class="d-flex justify-center font-weight-bold text-decoration-underline">
        CSM Notes
      </v-card-title>
      <v-card-text class="d-flex justify-space-around">
        <v-data-table
            :loading="loading"
            :headers="headers"
            :items="csmNotes.data"
            :items-per-page="10"
            class="elevation-1 table"
        >
          <template v-slot:[`item.dateCreated`]="{ item }">
            <td>
              {{ dateToLocaleTimeDateString(item.dateCreated) }}
            </td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn @click="newNote">
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
    <new-csm-note-dialog :is-open="isNewCsmNoteDialogOpen" :client-id="clientId"
                         @close="closeDialog"/>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {LoadingState} from "@/store/constants";
import {dateToLocaleTimeDateString} from "../../../helpers/dateHelper";
import NewCsmNoteDialog from "@/components/HealthScore/CsmNotes/NewCsmNoteDialog.vue";

export default {
  components: {NewCsmNoteDialog},
  props: {
    clientId: Number
  },
  computed: {
    ...mapState('healthScoreStore', ['csmNotes']),
    loading() {
      return this.csmNotes.state === LoadingState.LOADING
    },
  },
  data: () => ({
    isNewCsmNoteDialogOpen: false,
    headers: [
      {
        text: 'CSM',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      {text: 'Date', value: 'dateCreated'},
      {text: 'Note', value: 'text'},
    ],
  }),
  methods: {
    dateToLocaleTimeDateString,
    closeDialog() {
      this.isNewCsmNoteDialogOpen = false;
    },
    newNote() {
      this.isNewCsmNoteDialogOpen = true;
    },
  }
}
</script>
<style>
.table {
  width: 100%;
}
</style>
